// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-weight .weight-description {
  padding: 12px;
  background-color: white;
  border: 1px solid var(--gray);
  border-radius: 8px;
  max-width: 264px;
  margin: 40px auto 16px;
}

.page-weight .weight-description.normal {
  border: 1px solid var(--green);
}

.page-weight .weight-description.underweight {
  border: 1px solid var(--yellow);
}


.page-weight .weight-description.overweight {
  border: 1px solid var(--red);
}`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/weight.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;;AAGA;EACE,4BAA4B;AAC9B","sourcesContent":[".page-weight .weight-description {\n  padding: 12px;\n  background-color: white;\n  border: 1px solid var(--gray);\n  border-radius: 8px;\n  max-width: 264px;\n  margin: 40px auto 16px;\n}\n\n.page-weight .weight-description.normal {\n  border: 1px solid var(--green);\n}\n\n.page-weight .weight-description.underweight {\n  border: 1px solid var(--yellow);\n}\n\n\n.page-weight .weight-description.overweight {\n  border: 1px solid var(--red);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
